module.exports = ".mleft {\n  margin-left: 10px; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/views/consultants/consultants.component.scss
// module id = ./src/app/views/consultants/consultants.component.scss
// module chunks = main